import React, {PropTypes} from 'react';
import ClassNames from 'classnames';

const CardPanel = ({className, children, ...props}) => {
    const classes = {
        'card-panel': true
    };

    return (
        <div className={ClassNames(classes, className)}>
            <span>{children}</span>
        </div>
    );
};

CardPanel.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};

export default CardPanel;